import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { navy, muted, borderSoft, bgApp } from '../Layout/Resources/Theme'

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 56px 24px;
  color: ${muted};
`

const Icon = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: ${bgApp};
  border: 1px solid ${borderSoft};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: ${navy};
  font-size: 1.5rem;
`

const Title = styled.h3`
  margin: 0 0 6px;
  color: ${navy};
  font-size: 1.05rem;
  font-weight: 700;
`

const Text = styled.p`
  margin: 0;
  max-width: 320px;
  font-size: 0.88rem;
  line-height: 1.45;
`

const EmptyState = ({ icon, title, text, action }) => (
  <Wrap>
    <Icon><i className={icon || 'fa fa-inbox'} /></Icon>
    <Title>{title}</Title>
    {text ? <Text>{text}</Text> : null}
    {action ? <div style={{ marginTop: 18 }}>{action}</div> : null}
  </Wrap>
)

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.node,
  text: PropTypes.node,
  action: PropTypes.node
}

EmptyState.defaultProps = {
  icon: 'fa fa-inbox',
  title: 'Sin registros',
  text: null,
  action: null
}

export default EmptyState
